import { useEffect } from 'react';
import {
  InputComponent,
  PercentInputComponent,
  CurrencyInputComponent,
  SelectComponent,
} from '@dnhb/node_package';
import PropTypes from 'react-proptypes';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { useDispatch } from 'shared/hooks';
import { dispatchMapper, SYNC, NAVIGATE } from '../../../shared/wizard/actions';
import { shapeOutput, shapeInput } from '../config';

const WizardLanding = ({ input, sync, output }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { errors } = output;

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
  }, []);

  return (
    <form onSubmit={(e) => { e.preventDefault(); dispatch({ type: NAVIGATE, index: 1, validate: true }); }}>
      <input type="submit" className="hidden" />
      <br />
      <div className="wrapper">
        <div className="row">
          <div className="col-xs-12">
            <h3>Hypotheekvorm</h3>
          </div>
        </div>
        <div className="row">
          <div className="group col-xs-12">
            <SelectComponent
              options={[
                {
                  value: 1,
                  label: 'Aflossingsvrij',
                },
                {
                  value: 6,
                  label: 'Annuïtair',
                },
                {
                  value: 7,
                  label: 'Lineair',
                },
              ]}
              value={input.mortgage_type ? {
                label: input.mortgage_label,
                value: input.mortgage_type,
              } : null}
              onChange={(option) => {
                sync('mortgage_type', option.value);
                sync('mortgage_label', option.label);
                if (location.pathname !== '/') dispatch({ type: NAVIGATE, index: 0 });
              }}
              className="react-select"
              id="mortgage_type"
              label="Maak een keuze"
              errors={errors.mortgage_type}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h3>Gewenst hypotheekbedrag</h3>
          </div>
        </div>
        <div className="row">
          <div className="group col-xs-12">
            <CurrencyInputComponent
              id="amount"
              onChangeHandler={(e) => {
                sync('amount', e.target.value);
                if (location.pathname !== '/') dispatch({ type: NAVIGATE, index: 0 });
              }}
              value={input.amount}
              errors={errors.amount}
              label="Bedrag"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h3>Gewenste looptijd hypotheek</h3>
          </div>
        </div>
        <div className="row">
          <div className="group col-xs-12">
            <InputComponent
              name="years"
              onChangeHandler={(e) => {
                sync('years', e.target.value ? parseInt(e.target.value, 10) : null);
                if (location.pathname !== '/') dispatch({ type: NAVIGATE, index: 0 });
              }}
              value={input.years || ''}
              errors={errors.years}
              label="Aantal jaren"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h3>Gewenste hypotheekrente</h3>
          </div>
        </div>
        <div className="row">
          <div className="group col-xs-12">
            <PercentInputComponent
              id="interest_rate"
              onChangeHandler={(e) => {
                sync('interest_rate', e.target.value);
                if (location.pathname !== '/') dispatch({ type: NAVIGATE, index: 0 });
              }}
              value={input.interest_rate}
              errors={errors.interest_rate}
              label="Rente"
            />
          </div>
        </div>
      </div>
    </form>
  );
}

WizardLanding.propTypes = {
  sync: PropTypes.func.isRequired,
  input: shapeInput.isRequired,
  output: shapeOutput.isRequired,
};

WizardLanding.defaultProps = {};

export default connect(
  state => ({
    recalculating: state.recalculating,
    syncing: state.syncing,
    input: state.input,
    output: state.output,
    pages: state.pages,
  }),
  dispatchMapper,
)(WizardLanding);
